(($, Drupal) => {
  const initAccordion = (el) => {
    const $parent = $(el);
    const toggler = $parent.find('.accordion__toggler');
    const links = $parent.find('a');

    if (toggler.length === 0) {
      return;
    }

    const $body = $parent.find('.accordion__body');
    const $content = $parent.find('.accordion__content');

    $body.css({ height: 0, overflow: 'hidden' });

    if (links && links.length > 0) {
      links.attr('tabindex', '-1');
    }

    $body.show();

    let contentHeight = $content.outerHeight();

    const observer = new ResizeObserver((entries) => {
      const e = entries[0];
      contentHeight = e.borderBoxSize[0].blockSize;
    });

    observer.observe($content[0]);

    const onExpand = () => {
      $body.css('overflow', 'visible');
      if (links && links.length > 0) {
        links.attr('tabindex', '0');
      }
      toggler.attr('aria-label', 'Dölj FAQ');

      $body.off('transitionend', null, onExpand);
    };

    const onCollapse = () => {
      $parent.removeClass('expanded');
      if (links && links.length > 0) {
        links.attr('tabindex', '-1');
      }
      toggler.attr('aria-label', 'Visa FAQ');

      $body.off('transitionend', null, onCollapse);
    };

    toggler.on('click', (e) => {
      e.preventDefault();
      if (toggler.hasClass('collapse')) {
        $body.css({
          height: 0,
          transition: 'height .3s ease-in-out',
          overflow: 'hidden',
        });
        $body.on('transitionend', onCollapse);
        return toggler.removeClass('collapse');
      }
      const others = $parent.parents('.accordion-root').find('.accordion__toggler.collapse');
      if (others && others.length > 0) {
        others.trigger('click');
      }
      $parent.addClass('expanded');
      $body.css({
        height: contentHeight,
        transition: 'height .3s ease-in-out',
      });
      $body.on('transitionend', onExpand);
      return toggler.addClass('collapse');
    });

    $(window).on('resize', () => {
      contentHeight = $content.outerHeight();

      if (toggler.hasClass('collapse')) {
        $body.css({ height: contentHeight });
      }
    });
  };

  Drupal.behaviors.mstAccordion = {
    attach: (context) => {
      $('.accordion', context).each((index, element) => initAccordion(element));
    },
  };
})(jQuery, Drupal);
